import * as R from 'ramda';
import { memoizeOneFactory } from 'core/memoizer';
import converter from './py2jsCssProperties';
import { ifColumnId, ifColumnType, ifEditable } from 'dash-table/conditional';
import { QuerySyntaxTree } from 'dash-table/syntax-tree';
import { BORDER_PROPERTIES_AND_FRAGMENTS } from '../edges/type';
import { matchesDataCell, matchesDataOpCell, matchesFilterCell, getFilterOpStyles, matchesHeaderCell, getHeaderOpStyles } from 'dash-table/conditional';
function convertElement(style) {
    const indexFilter = style.if && (style.if.header_index || style.if.row_index);
    let ast;
    return {
        checksColumn: () => !R.isNil(style.if) && (!R.isNil(style.if.column_id) ||
            !R.isNil(style.if.column_type) ||
            !R.isNil(style.if.column_editable)),
        checksRow: () => !R.isNil(indexFilter),
        checksFilter: () => !R.isNil(style.if) && !R.isNil(style.if.filter_query),
        matchesColumn: (column) => !style.if || (!R.isNil(column) &&
            ifColumnId(style.if, column && column.id) &&
            ifColumnType(style.if, column && column.type) &&
            ifEditable(style.if, column && column.editable)),
        matchesRow: (index) => indexFilter === undefined ?
            true :
            typeof indexFilter === 'number' ?
                index === indexFilter :
                !R.isNil(index) && (indexFilter === 'odd' ? index % 2 === 1 : index % 2 === 0),
        matchesFilter: (datum) => !style.if ||
            style.if.filter_query === undefined ||
            (ast = ast || new QuerySyntaxTree(style.if.filter_query)).evaluate(datum),
        style: convertStyle(style)
    };
}
function convertStyle(style) {
    return R.reduce((res, [key, value]) => {
        if (converter.has(key)) {
            res[converter.get(key)] = value;
        }
        return res;
    }, {}, R.toPairs(style));
}
export const derivedRelevantCellStyles = memoizeOneFactory((cell, dataCell, cells, dataCells) => R.unnest([
    cell ? [convertElement(cell)] : [],
    R.map(convertElement, cells || []),
    dataCell ? [convertElement(dataCell)] : [],
    R.map(convertElement, dataCells || [])
]));
export const derivedRelevantFilterStyles = memoizeOneFactory((cell, filter, cells, filters) => R.unnest([
    cell ? [convertElement(cell)] : [],
    R.map(convertElement, cells || []),
    filter ? [convertElement(filter)] : [],
    R.map(convertElement, filters || [])
]));
export const derivedRelevantHeaderStyles = memoizeOneFactory((cell, header, cells, headers) => R.unnest([
    cell ? [convertElement(cell)] : [],
    R.map(convertElement, cells || []),
    header ? [convertElement(header)] : [],
    R.map(convertElement, headers || [])
]));
export const derivedTableStyle = memoizeOneFactory((defaultTable, table) => [
    convertStyle(defaultTable),
    convertStyle(table)
]);
export function resolveStyle(styles) {
    let res = {};
    for (let i = 0; i < styles.length; ++i) {
        Object.assign(res, styles[i].style);
    }
    return R.omit(BORDER_PROPERTIES_AND_FRAGMENTS, res);
}
export const getDataCellStyle = (datum, i, column) => (styles) => resolveStyle(matchesDataCell(datum, i, column)(styles));
export const getDataOpCellStyle = (datum, i) => (styles) => resolveStyle(matchesDataOpCell(datum, i)(styles));
export const getFilterCellStyle = (column) => (styles) => resolveStyle(matchesFilterCell(column)(styles));
export const getFilterOpCellStyle = () => (styles) => resolveStyle(getFilterOpStyles(styles));
export const getHeaderCellStyle = (i, column) => (styles) => resolveStyle(matchesHeaderCell(i, column)(styles));
export const getHeaderOpCellStyle = (i) => (styles) => resolveStyle(getHeaderOpStyles(i)(styles));
